/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GhlService {
    /**
     * Connect a GHL account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully connected a GHL account
     * @throws ApiError
     */
    public static postGhl(
        workspaceId: string,
        requestBody: {
            code: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ghl',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List connected GHL accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List connected GHL accounts
     * @throws ApiError
     */
    public static getGhl(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ghl',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Disconnect a GHL account
     * @param id The id of api key
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully disconnected a GHL account
     * @throws ApiError
     */
    public static deleteGhl(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/ghl/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update a GHL account
     * @param id The id of api key
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully updated a GHL account
     * @throws ApiError
     */
    public static putGhl(
        id: string,
        workspaceId: string,
        requestBody: {
            source_filter: string;
            pipeline_filter: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/ghl/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Connect a GHL account
     * @param requestBody
     * @returns any Successfully connected a GHL account
     * @throws ApiError
     */
    public static postGhlEvents(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ghl/events',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
